import React from "react";

const PositiveFaceIcon = (props) => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g id="face-smile">
      <g transform="translate(1.5, 1.5)">
        <path id="Fill" opacity="0.12" d="M7.5 15C11.6421 15 15 11.6421 15 7.5C15 3.35786 11.6421 0 7.5 0C3.35786 0 0 3.35786 0 7.5C0 11.6421 3.35786 15 7.5 15Z" fill="currentColor" />
      </g>
      <g transform="translate(1, 1)">
        <path id="Icon" d="M5 9.5C5 9.5 6.125 11 8 11C9.875 11 11 9.5 11 9.5M10.25 5.75H10.2575M5.75 5.75H5.7575M15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5C12.1421 0.5 15.5 3.85786 15.5 8ZM10.625 5.75C10.625 5.95711 10.4571 6.125 10.25 6.125C10.0429 6.125 9.875 5.95711 9.875 5.75C9.875 5.54289 10.0429 5.375 10.25 5.375C10.4571 5.375 10.625 5.54289 10.625 5.75ZM6.125 5.75C6.125 5.95711 5.95711 6.125 5.75 6.125C5.54289 6.125 5.375 5.95711 5.375 5.75C5.375 5.54289 5.54289 5.375 5.75 5.375C5.95711 5.375 6.125 5.54289 6.125 5.75Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      </g>
    </g>
  </svg>
);

export default PositiveFaceIcon;
